package com.rabbitsign.common

import kotlinx.serialization.Serializable

@Serializable
data class UploadUrl(val uploadUrl: String)
